import React, { Component } from "react";
import { Button, ProgressBar } from "react-bootstrap";
import { render } from "react-dom";
import { object } from "prop-types";
import _ from "lodash";
import classNames from "classnames";
import axios from "axios";
import config from "../../config";
// c3
import C3Chart from "react-c3js";
import "c3/c3.css";

class BarFunnelByViewer extends Component {
  constructor(props) {
    super(props);

    let uniqueId = "barFunnelByViewer" + this.props.video.id;

    this.state = {
      isLoading: false,
      hasError: false,
      isEmpty: false,
      uniqueId: uniqueId,
      progressBarValue: 0,
      done: false
    };

    this.mergeResults = this.mergeResults.bind(this);
    this.sumResults = this.sumResults.bind(this);
    this.mountAndPlot = this.mountAndPlot.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  mergeResults(data) {
    let output = {};

    data.forEach(events_by_viewer => {
      _.forEach(events_by_viewer, (events, viewer_id) => {
        if (typeof output[viewer_id] === "undefined") {
          output[viewer_id] = {};
        }

        _.merge(output[viewer_id], events);
      });
    });

    return output;
  }

  sumResults(data) {
    var output = {};

    _.forEach(data, (events, viewer_id) => {
      _.forEach(events, (count, name) => {
        if (typeof output[name] === "undefined") {
          output[name] = 0;
        }

        output[name] = output[name] + count;
      });
    });

    return output;
  }

  handleClick() {
    this.mountAndPlot(this.props);
  }

  mountAndPlot(props) {
    let { video } = props;
    this.setState({
      isLoading: true,
      hasError: false,
      isEmpty: false,
      progressBarValue: 0,
      done: false
    });
    this.startProgressBar();

    let url = `${config.trackingReportUrl}/videos/${video.id}/bar_funnel`;

    axios({
      method: "POST",
      headers: { Accept: "application/json; charset=utf-8" },
      url: url,
      data: {
        start_date: this.props.timeframe.start,
        end_date: this.props.timeframe.end,
        group_by_viewer: true
      }
    })
      .then(res => {
        console.log("res.data: ", res.data);

        let mergedData = this.mergeResults(res.data);
        console.log("mergedData: ", mergedData);

        let finalData = this.sumResults(mergedData);
        console.log("finalData: ", finalData);

        let funnelData = finalData;
        console.log("funnelData: ", funnelData);

        const data = {
          columns: [["Pessoas", funnelData.cliques, funnelData.visitas, funnelData.plays]],
          type: "bar",
          labels: true
        };
        const axis = {
          x: {
            type: "category",
            categories: ["Cliques", "Visitas", "Plays"]
          }
        };
        const mountNode = document.getElementById(this.state.uniqueId);
        const chart = <C3Chart data={data} axis={axis} />;
        render(chart, mountNode);
        this.setState({
          isLoading: false,
          hasError: false,
          isEmpty: false,
          progressBarValue: 100,
          done: true
        });
      })
      .catch(err => {
        console.log("Deu erro!", err);
      });
  }

  startProgressBar() {
    var self = this;
    const counter = setInterval(function() {
      if (self.state.progressBarValue === 95) {
        clearInterval(counter);
      } else {
        self.setState({
          progressBarValue: self.state.progressBarValue + 1
        });
      }
    }, 1200);
  }

  render() {
    let { uniqueId, isLoading, hasError, isEmpty, progressBarValue, done } = this.state;
    return (
      <div>
        <p style={done ? { display: "none" } : { textAlign: "center" }}>
          O carregamento do funil pode demorar até 2 minutos. Clique abaixo para começar.
        </p>
        <div style={isLoading ? {} : { display: "none" }}>
          <ProgressBar now={progressBarValue} label={`${progressBarValue}%`} />
        </div>
        <div className={classNames({ hidden: isLoading || isEmpty })}>
          <div id={uniqueId} />
        </div>
        <div style={done ? { display: "none" } : { textAlign: "center" }}>
          <Button bsStyle="primary" disabled={isLoading} onClick={!isLoading ? this.handleClick : null}>
            {isLoading ? "Carregando..." : "Carregar Funil"}
          </Button>
        </div>
      </div>
    );
  }
}

BarFunnelByViewer.propTypes = {
  timeframe: object,
  campaign: object
};

export default BarFunnelByViewer;



// WEBPACK FOOTER //
// ./src/components/charts/BarFunnelByViewer.js